<template>
 <v-card class="d-flex flex-column my-4">
  <span v-if="content.cont_content_id == 1">
    <div class="pa-3 border-bottom" style="background-color: #f2f2f2;">
   
      <h3 class="mb-2">
          Dr. Ulrich Hofmann, Bayreuth verlinkt die WaizmannTabelle:
        </h3>
    </div>
    
    <div class="pa-4" >
   
        <p>
          <img
            :src="require('@/assets/userbilder/hofmann.jpg')"
            class="img-rounded"
            style="width: 80px; float: left; margin: 0px 10px 0px 0px"
          />
          <em
            >"Wir verlinken seit Kurzem auf die WaizmannTabelle für Erwachsene
            und für Kinder. Es ist eine gute und schnelle Informationsplattform
            für unsere Patienten, die eine Zahnzusatzversicherung suchen."</em
          >
        </p>
    </div>
</span>

<span v-if="content.cont_content_id == 2">
    <div class="pa-3 border-bottom" style="background-color: #f2f2f2;">
   
      <h3 class="mb-2">
        Dr. Marco Lovisa, Schwelm verlinkt die WaizmannTabelle:
        </h3>
    </div>
    
    <div class="pa-4" >
   <p>
      <img
            :src="
              require('@/assets/userbilder/waizmanntabelle_zahnarzt_lovisa.jpg')
            "
            class="img-rounded"
            style="width: 80px; float: left; margin: 0px 10px 0px 0px"
          />
          <em
            >"Ich verlinke die Waizmann-Tabelle, weil sie hilft, Licht ins
            Dickicht des Kleingedruckten der Versicherungen zu bringen. Sie ist
            deshalb ein nützliches Beratungsinstrument für ratsuchende
            Patienten, die in der Regel am wenigsten von der Materie der
            Krankenversicherungen verstehen. Das Erwachen kommt leider oft erst
            nach der Unterschrift."</em
          >
        </p>
    </div>
</span>


<span v-if="content.cont_content_id == 3">
    <div class="pa-3 border-bottom" style="background-color: #f2f2f2;">
   
      <h3 class="mb-2">
        Dr. Rolf Saatjohann, Horstmar verlinkt die WaizmannTabelle:
        </h3>
    </div>
    
    <div class="pa-4" >
      <p>
          <img
            :src="
              require('@/assets/userbilder/waizmanntabelle_zahnarzt_saatjohann.jpg')
            "
            class="img-rounded"
            style="width: 80px; float: left; margin: 0px 10px 0px 0px"
          />
          <em
            >"Immer wieder fragen Patienten nach, welche Zahnzusatzversicherung
            empfehlenswert ist. Leider ist dieser Markt auch für uns nicht
            überschaubar, da die Tarife sich zur Zeit noch ständig ändern, bzw.
            ganz neue Produkte auf den Markt kommen. Daher sind Empfehlungen von
            Tests häufig nach kurzer Zeit überholt. Ich habe die WaizmannTabelle
            verlinkt um meinen Patienten die Möglichkeit einer einfachen und
            objektiven Information über ein schwer zu durchschauenden Markt zu
            geben."</em
          >
        </p>
    </div>
</span>
  </v-card>
</template>

<script setup>
import { defineProps } from "vue";
const props = defineProps({
  content: {
    type: Object,
    required: true
  }
});
console.log(props.content.cont_id)
</script>
